var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMenuChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "#242424",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.933325 0.399976L4 3.5L6.93333 0.399976L8 1.52354L4 5.59998L4.8611e-08 1.52354L0.933325 0.399976Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenuChevronDown);
export default __webpack_public_path__ + "static/media/ico-menu-chevron-down.748bd53f32f3124f428fa8c2296228ec.svg";
export { ForwardRef as ReactComponent };